import { TeacherAssignmentQuestionTypesEnum } from '@school_ify/schoolify-repository/src/teacher/types';

// eslint-disable-next-line import/prefer-default-export
export const getQuestionTypeFromString = (type: string) => {
  let enumQuestionType;
  switch (type) {
    case TeacherAssignmentQuestionTypesEnum.FILL_IN_BLANK:
      enumQuestionType = TeacherAssignmentQuestionTypesEnum.FILL_IN_BLANK;
      break;
    case TeacherAssignmentQuestionTypesEnum.MATCHING:
      enumQuestionType = TeacherAssignmentQuestionTypesEnum.MATCHING;
      break;
    case TeacherAssignmentQuestionTypesEnum.OPEN_QUESTION:
      enumQuestionType = TeacherAssignmentQuestionTypesEnum.OPEN_QUESTION;
      break;
    case TeacherAssignmentQuestionTypesEnum.PICK_OPTIONS:
      enumQuestionType = TeacherAssignmentQuestionTypesEnum.PICK_OPTIONS;
      break;
    default:
      enumQuestionType = null;
  }
  return enumQuestionType;
};
